import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

export function initDatadogRum() {
  datadogRum.init({
    applicationId: "aa0b6d74-501f-4150-bccd-e07539e5d764",
    clientToken: "pub359a183b427fc18b8fe53a18f4281f2b",
    site: "datadoghq.com",
    service: "singular-imaging-react",
    env: import.meta.env.DEV ? "dev" : import.meta.env.VITE_DD_ENV || "test",
    version: "1.0.0",
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackBfcacheViews: true,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: true })],
  });
}
